import script from "./GestionRubricasView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GestionRubricasView.vue?vue&type=script&setup=true&lang=ts"

import "./GestionRubricasView.vue?vue&type=style&index=0&id=cc73f7ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc73f7ec"]])

export default __exports__